import { useRef, useEffect, useState, useMemo } from "react";
import IMAGES from "../../assets/images/images";
import {areAdjacent, CONTAINER_SIZE,getDynamicLayoutOrder,HEADER,MY_CUSTOMER,roleBasedWidgetMap,roleLayoutOrderMap,shouldBeFullWidthSmall,shouldStackMedium,WIDGET_NAME,} from "../../utils/constants/homeConstants";
import SizeContainer from "./container/SizeContainer";
import styles from "./home.module.css";
import AccountManagerWidget from "./widgets/accountmanagerwidget/AccountManagerwidget";
import GraphWidget from "./widgets/graphwidget/GraphWidget";
import LiveServicewidgets from "./widgets/liveservicewidgets/LiveServicewidget";
import Mapwidgets from "./widgets/mapwidgets/Mapwidgets";
import PendingActionwidget from "./widgets/pendingactionwidget/PendingActionwidget";
import QuickLinksWidget from "./widgets/quicklinkswidget/QuickLinkswidget";
import BarGraphwidget from "./widgets/bargraphwidget/BarGraphwidget";
import CustomerDetail from "./widgets/customerdetailwidget/CustomerDetail";
import CustomDropdownMenu from "../../components/customDropdown/CustomDropdown";
import BroadCastPopup from "../../components/broadCastPopup/broadcastPopup";
import BroadCastWidget from "./widgets/broadcastwidget/BroadCastWidget";
import Shimmer from "../../components/shimmer/Shimmer";
import { Incident_Service_Type_Values } from "../../utils/constants/incidentConstants";
import { Link } from "react-router-dom";
import CAN from "../../casl/can"
import { Action, Resource } from "../../casl/constants";
import { formatDate } from "../../utils/arrayUtils";
import SecondaryTooltip from "../../components/secondaryToolTip/secondaryToolTip";
import { handleDownload } from "../../utils/utils";
import SectionGuard from "../../hoc/guards/SectionGuard";
import { USER_TYPE } from "../../utils/constants/userConstants";
import { Container } from "../../components/Container/Containers";
import { Banner } from "../../components/banner/Banners";

const Home = ({ customerData,...props }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const isInternalLogin = props?.myRights?.userType === USER_TYPE.INTERNAL;
  const headers = isInternalLogin ? HEADER.INTERNAL : HEADER.CUSTOMER;

  const gotoDetailPage = (id) => id ? `/user-management/customerdetail/${id}` : "#";

  const widgetComponentMap = useMemo(() => ({
    [WIDGET_NAME.WORLDWIDE_POPS_COUNT_WIDGET]: (props) => (
      <Mapwidgets {...props} />
    ),
    [WIDGET_NAME.LIVE_SERVICES_COUNT_WIDGET]: (props) => (
      <LiveServicewidgets {...props} />
    ),
    [WIDGET_NAME.USERS_INACTIVITY_COUNT_WIDGET]: (props) => (
      <LiveServicewidgets {...props} />
    ),
    [WIDGET_NAME.ONBOARDED_CUSTOMERS_COUNT_WIDGET]: (props) => (
      <LiveServicewidgets {...props} />
    ),
    [WIDGET_NAME.INCIDENT_MANAGEMENT_STATUS_COUNT_WIDGET]: (props) => (
      <GraphWidget {...props} />
    ),
    [WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET]: (props) => (
      <GraphWidget {...props} />
    ),
    [WIDGET_NAME.PENDING_ACTION_NOTIFICATION_WIDGET]: (props) => (
      <PendingActionwidget {...props} />
    ),
    [WIDGET_NAME.QUICK_LINKS_WIDGET]: (props) => (
      <QuickLinksWidget {...props} />
    ),
    [WIDGET_NAME.CUSTOMER_ACCOUNT_MANAGERS_WIDGET]: (props) => (
      <AccountManagerWidget {...props} />
    ),
    [WIDGET_NAME.CUSTOMER_DETAILS_WIDGET]: (props) => (
      <CustomerDetail {...props} />
    ),
    [WIDGET_NAME.CUSTOMER_PRIMARY_CONTACT_DETAILS_WIDGET]: (props) => (
      <CustomerDetail {...props} />
    ),
    [WIDGET_NAME.ACCOUNT_MANAGERS_LIST_WIDGET]: (props) => (
      <CustomerDetail {...props} />
    ),
    [WIDGET_NAME.CUSTOMER_APPROVER_DETAILS_WIDGET]: (props) => (
      <CustomerDetail {...props} />
    ),
    [WIDGET_NAME.STATUS_WISE_INTERNAL_USERS_COUNT_WIDGET]: (props) => (
      <BarGraphwidget {...props}/>
    ),
    [WIDGET_NAME.STATUS_WISE_CUSTOMER_USERS_COUNT_WIDGET]: (props) => (
      <GraphWidget {...props} />
    ),
    [WIDGET_NAME.SCHEDULED_BROADCAST_MESSAGE_WIDGET]: (props) => (
      <BroadCastWidget {...props} />
    ),
    [WIDGET_NAME.CUSTOMER_ONBOARDING_REQUESTS_WIDGET]: (props) => (
      <GraphWidget {...props} />
    ),
  }),[]);
  const getWidgetComponent = (widgetName) => widgetComponentMap[widgetName] || null
  // const renderLayout = roleBasedWidgetMap[props?.myRights?.userType===USER_TYPE?.INTERNAL ? props?.myRights?.functionalRoles[0]:"customer"];
  const renderLayout = props.widgetLayout?.data
  const largeLayout = renderLayout?.large || [];
  const mediumLayout = renderLayout?.medium || [];
  const isLargeCountOdd = largeLayout.length % 2 !== 0;
  const isMediumllCountOdd = mediumLayout.length % 2 !== 0;
  const stackedMediums = isLargeCountOdd ? mediumLayout.slice(0, 2) : [];
  const layoutOrder = getDynamicLayoutOrder(renderLayout);
  const isStack = areAdjacent(layoutOrder, CONTAINER_SIZE.LARGE, CONTAINER_SIZE.MEDIUM)
  const orderedWidgets = useMemo(() => {
    if(!props.widgetLayout?.data) return [];
    return layoutOrder.flatMap((layoutKey) => {
      const widgets = renderLayout?.[layoutKey] || [];
      return widgets.map(widget => ({
        ...widget,
        layoutGroup: layoutKey,
      }));
    });
  }, [renderLayout, layoutOrder]);
  
  const renderWidget = (widget, index,selectedCustomerId) => {
    const isFullWidth = widget.layoutGroup === CONTAINER_SIZE.SMALL && shouldBeFullWidthSmall(index, renderLayout.small.length);
    const WidgetComponent = getWidgetComponent(widget.widgetName);
    return (
      <SizeContainer
        key={`widget-${index}`}
        containersize={widget.layoutType}
        isFullWidth={isFullWidth}
      >
        {WidgetComponent ? <WidgetComponent action={widget.widgetName} isFullWidth={isFullWidth} isStack={isStack} {...widget} selectedCustomerId={selectedCustomerId} myRights={props?.myRights} /> : null}
      </SizeContainer>
    );
  };

  const handleClick = (item) => {
    setShowPopup(true);
    setActiveItem(item)
  };
  const handleCancel = () => {
    setShowPopup(false);
    setActiveItem(null)
  };

  useEffect(()=>{
    // props.getUserReport();
    props?.getServices();
    if(CAN(Action.LIST,Resource.FILTER_CUSTOMERS) || CAN(Action.LIST,Resource.CUSTOMERS)){
      props?.getFilteredCustomers();
    }
    props?.getWidgetLayoutConfig();
  },[])

  const dropdownOptions = useMemo(() => {
    return props?.filterCustomers?.data?.map((customer) => ({
      value: customer?.uniqueCustomerRefId,
      label: customer?.displayName,
      type: customer?.serviceType
    })) || [];
  }, [props?.filterCustomers?.data]);
  useEffect(() => {
    if (dropdownOptions?.length > 0 && !selectedOption) {
      setSelectedOption(dropdownOptions[0]);
    }
  }, [dropdownOptions]);
  
  const selectedCustomerId = selectedOption?.value
  return (
    <Container>
    <Banner image={IMAGES.vfbanner} text={"Welcome to IPXplore"}></Banner>
    <div className={styles.notewrapper}>
    { props.broadCastnotification?.broadCastnotification?.data?.map((item)=>(
    <div className={styles.note}>
        <div className={styles.noteellipsis}>
       {/* <span className={styles.boldnote}>New Feature Alert!</span> */}
       <span className={styles.noteText}><span className={styles.indicate}></span> <span className={styles.txtmsg}>{item.title}</span></span></div>
       <div className={styles.notelink} onClick={() => handleClick(item)}>Check out now</div>
     </div>  
      ))}
    </div>
      {showPopup&&
          <BroadCastPopup
          header={activeItem.title}
          data={activeItem.message}
          onCancel={handleCancel}
          showPopup={showPopup}
      />}
      <div className={`${props?.broadCastnotification?.broadCastnotification?.data?.length>0?styles.manageConatiner:styles.container}`}>
      <div className={styles.subheader}>
          <div className={styles.heading}>My Dashboard</div>
          {/* <SectionGuard canAccess={CAN(Action.LIST,Resource.RIGHTS_REPORT)}> 
            <div className={styles.wraper}>
              <span className={styles.reportnote}>Lorem Ipsum dolores Lorem Ipsum dolores  </span>
            <SecondaryTooltip text={"User's Report"} positions={['bottom', 'right']}>
              <div className={`${props.userReport.loading ? styles.excelloading:styles.exceldownload}`} onClick={ ()=>{
                if(!props.userReport.loading){
                  handleDownload(props.userReport.data.userDetails)
                }
              }  }><img src={IMAGES.xlsxLogo} className={styles.xlsxLogo}/></div>
            </SecondaryTooltip>
            </div>
          </SectionGuard> */}
        </div>
        <div className={styles.flexRow}>
        {(props.widgetLayout?.data?.length===0 && props.widgetLayout?.isLoading)&&(
          <div className={`${props?.broadCastnotification?.broadCastnotification?.data?.length>0?styles.manageshimmeContainer:styles.shimmeContainer}`}><Shimmer/></div>
        )}
        {orderedWidgets.map((widget, index) => {
          if (widget.layoutType === CONTAINER_SIZE.CUSTOM && widget.data) {
            const nestedData = widget.data || [];
            const largeNested = selectedOption?.type===Incident_Service_Type_Values.IVC_Service ? nestedData.filter(w => w.layoutType === CONTAINER_SIZE.LARGE && w.widgetName!==WIDGET_NAME.DEMANDS_STATUS_COUNT_WIDGET) : nestedData.filter(w => w.layoutType === CONTAINER_SIZE.LARGE);
            const extraSmallNested = nestedData.filter(w => w.layoutType === CONTAINER_SIZE.EXTRA_SMALL);
            const shouldStackSmalls = largeNested.length % 2 !== 0 && extraSmallNested.length > 0;
            return (
              <div key={`extra-large-${index}`} className={`${nestedData?.length>1?styles.fullRow:!isMediumllCountOdd?styles.managerow:styles.mediumfullrow}`}>
                {widget?.customerDropdown&&(<div className={`${styles.custwrapper}`}>
                    <div className={styles.orglabel}>Select Organisation Name</div>
                    <div className={styles.header}>
                      <div className={styles.headtext}><SecondaryTooltip text={`${selectedOption?.label?selectedOption?.label:""}`} positions={['bottom', 'right']}><span className={`${styles.value} ${styles.valueText}`}>{`${selectedOption?.label?selectedOption?.label:""}`}{" "}</span></SecondaryTooltip></div>
                        <CustomDropdownMenu
                          header={headers.ORG_LEGAL_NAME}
                          options={dropdownOptions}
                          selectedValue={selectedOption}
                          customheight={"customcss"}
                          quickSerach={true}
                          type={"serviceType"}
                          placeholder="Search by Organisation Legal Name..."
                          onSelect={(option) => setSelectedOption(option)}
                          renderTrigger={(isOpen) => (
                            props?.customerLoading&&!selectedOption?.value?<div className={styles.shimmerlabel}><Shimmer/></div>:selectedOption?.value?<img className={`${styles.arrows} ${isOpen ? styles.rotateArrow : ""}`} src={IMAGES.arrows} alt="dropdown arrow"/>:<div className={styles.nodata}>No Data</div>
                          )}
                          isInternalLogin={isInternalLogin}
                        />
                    </div>
                    {customerData?.customerDetails?.serviceType?.value===Incident_Service_Type_Values.IPX_Service && !customerData?.customerDetails?.fincaTadigCode && (
                      <div className={styles.missingfincanote}>
                        <img src={IMAGES.Vector} className={styles.vector} />
                        <span className={styles.wrap}>
                        <spn className={styles.boldtext}>Invoice code</spn> not added for <spn>{customerData?.customerDetails?.displayName} </spn>
                        <SectionGuard canAccess={CAN(Action.UPDATE,Resource.CUSTOMERS)}> 
                          <Link to={gotoDetailPage(selectedCustomerId)} target="_blank" rel="noopener noreferrer" className={styles.addfinca}>click here</Link>
                        </SectionGuard>
                        </span>
                      </div>
                    )}
                    {customerData?.customerDetails?.serviceType?.value===Incident_Service_Type_Values.IVC_Service && !customerData?.customerDetails?.oneITSMAccountServiceName && (
                      <div className={styles.missingfincanote}>
                        <img src={IMAGES.Vector} className={styles.vector} />
                        <span className={styles.wrap}>
                        <spn className={styles.boldtext}> IVC service name</spn> not added for <spn>{customerData?.customerDetails?.displayName} </spn>
                        <SectionGuard canAccess={CAN(Action.UPDATE,Resource.CUSTOMERS)}> 
                          <Link to={gotoDetailPage(selectedCustomerId)} target="_blank" rel="noopener noreferrer" className={styles.addfinca}>click here</Link>
                        </SectionGuard>
                        </span>
                      </div>
                    )}
                    </div>
                    )}
                  <div className={nestedData?.length>1?styles.flexRow:""}>
                    {largeNested.map((nestedWidget, i) => renderWidget(nestedWidget, i,selectedCustomerId))}
                    {shouldStackSmalls ? (
                      <>
                      <div className={styles.stackedContainer}>
                        {extraSmallNested.slice(0, 3).map((sw, i) => renderWidget(sw, i, selectedCustomerId))}
                      </div>
                      <div className={styles.stackedhorizontal}>
                      {extraSmallNested.slice(3).map((sw, i) =>renderWidget(sw, i + 3, selectedCustomerId))}
                      </div>
                      </>
                    ) : (
                      extraSmallNested.map((sw, i) => renderWidget(sw, i, selectedCustomerId))
                    )}
                  </div>
              </div>
            );
          }
          if (isLargeCountOdd && isStack && shouldStackMedium(widget.widgetName, stackedMediums)) {
            if (stackedMediums[0].widgetName === widget.widgetName) {
              return (
                <div key={`stacked-medium-${index}`} className={styles.stackedContainer}>
                  {stackedMediums.map((stackedWidget, i) => renderWidget(stackedWidget, i))}
                </div>
              );
            }
            return null;
          }
          // Handle extra_large widgets in full width
          if (widget.layoutType === CONTAINER_SIZE.EXTRA_LARGE) {
            return (
            <div key={`extra-large-${index}`} className={!isStack?styles.managerow:styles.mediumfullrow}>
              {renderWidget(widget, index)}
            </div>
            );
          }
          return renderWidget(widget, index);
        })}
        </div>
      </div>
    </Container>
  );
};
export default Home;